
import axios from 'axios'
import API from "@api/api";
import { message } from 'antd';
import {isMobile} from 'react-device-detect';
import { IMAGE_TYPE } from "@utils/CONST"

    

function chunkArray(array, size) {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
}

// 抠出图像内容边廓矩形
function getTrimmedImageBase64(base64) {
    // console.time('=========getTrimmedImageBase64==========')
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64;
    img.onload = function() {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      let minX = canvas.width, minY = canvas.height, maxX = 0, maxY = 0;
      for (let y = 0; y < canvas.height; y++) {
        for (let x = 0; x < canvas.width; x++) {
          const index = (y * canvas.width + x) * 4;
          if (data[index + 3] > 0) {
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
            maxX = Math.max(maxX, x);
            maxY = Math.max(maxY, y);
          }
        }
      }
      const rectWidth = maxX - minX + 1;
      const rectHeight = maxY - minY + 1;
      const resultCanvas = document.createElement('canvas');
      resultCanvas.width = rectWidth;
      resultCanvas.height = rectHeight;
      const resultCtx = resultCanvas.getContext('2d');
      resultCtx.drawImage(canvas, minX, minY, rectWidth, rectHeight, 0, 0, rectWidth, rectHeight);
      const resultBase64 = resultCanvas.toDataURL();

      // console.timeEnd('=========getTrimmedImageBase64==========')
      resolve(resultBase64);
    };
    img.onerror = reject;
  });
}

// 将透明背景，加任意颜色内容转为黑底白色
function convertBase64Image(base64Image) {
    // console.time('=========convertBase64Image==========')
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      // 创建 Canvas 元素
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;

      // 在 Canvas 上绘制图像
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);

      // 获取像素数据
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      // 遍历像素数据，根据透明度设置颜色
      for (let i = 0; i < data.length; i += 4) {
        const alpha = data[i + 3];
        const color =alpha < 0.8 * 255 ? 0 : 255;
        data[i] = color;
        data[i + 1] = color;
        data[i + 2] = color;
        data[i + 3] = 255;
      }

      // 将处理后的像素数据绘制到 Canvas 上
      ctx.putImageData(imageData, 0, 0);

      // 将 Canvas 转换为 base64 编码的图片
      const newBase64Image = canvas.toDataURL('image/png');

      // console.timeEnd('=========convertBase64Image==========')
      resolve(newBase64Image);
    };
    img.onerror = reject;
    img.src = base64Image;
  });
}

function setOpaquePixels(base64Image) {
    // console.time('=========setOpaquePixels==========')
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;

      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

      for (let i = 0; i < imageData.data.length; i += 4) {
        const alpha = imageData.data[i + 3] / 255; // 转换为0-1范围的透明度值
        if (alpha >= 0.5) {
          imageData.data[i + 3] = 255;
        }
      }

      ctx.putImageData(imageData, 0, 0);
      const modifiedBase64 = canvas.toDataURL('image/png');

      // console.timeEnd('=========setOpaquePixels==========')
      resolve(modifiedBase64);
    };

    img.onerror = () => {
      reject(Error('Failed to load the image.'));
    };

    img.src = base64Image;
  });
}

// 原图加mask去除前景
function getForegroundImage(samOrign_1024, samClickMask) {
    // console.time('=========getForegroundImage==========')
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  function loadImage(src) {
    // console.time('=========loadImage==========')
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous"; // 允许跨域
        img.onload = () => {
            // console.timeEnd('=========loadImage==========')
            resolve(img)
        };
        img.onerror = reject;
        img.src = src;
    });
  }
  return new Promise((resolve, reject) => {
    Promise.all([
      loadImage(samOrign_1024),
      loadImage(samClickMask)
    ]).then(([originalImg, maskImg]) => {
      canvas.width = originalImg.width;
      canvas.height = originalImg.height;
      
      ctx.drawImage(originalImg, 0, 0);
      
      ctx.globalCompositeOperation = 'destination-in';
      
      ctx.drawImage(maskImg, 0, 0);
      
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const maskData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      
      for (let i = 0; i < imageData.data.length; i += 4) {
        const a = maskData.data[i + 3];
        if (a < 0) {
          imageData.data[i + 3] = 255; // 设置透明像素为不透明
        }
      }
      
      const base64 = canvas.toDataURL('image/png');
      
      // console.timeEnd('=========getForegroundImage==========')

      resolve(base64);
    });
  });
}

// 将原图base64  resize成1024为长边的图  背景不透明
function resizeBase64Image(base64, maxWidth = 1024) {
    // console.time('=========resizeBase64Image==========')
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = base64;
      img.onload = () => {
        const {width, height} = img;
        const ratio = width / height;
        const newWidth = ratio >= 1 ? maxWidth : Math.round(maxWidth * ratio);
        const newHeight = ratio >= 1 ? Math.round(maxWidth / ratio) : maxWidth;
        const canvas = document.createElement('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, newWidth, newHeight);
        const resizedBase64 = canvas.toDataURL('image/png');

        // console.timeEnd('=========resizeBase64Image==========')

        resolve(resizedBase64);
      };
      img.onerror = reject;
    });
}

function resizeLongestAndShort(base64, longestSide, shortestSide) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64;
    img.onload = () => {
      const { width, height } = img;
      
      let newWidth, newHeight;
      const ratio = width / height;
      
      if (ratio >= 1) {
        newWidth = longestSide;
        newHeight = shortestSide || Math.round(longestSide / ratio);
      } else {
        newWidth = shortestSide || Math.round(longestSide * ratio);
        newHeight = longestSide;
      }
      
      const canvas = document.createElement('canvas');
      canvas.width = newWidth;
      canvas.height = newHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, newWidth, newHeight);
      const resizedBase64 = canvas.toDataURL('image/png');

      resolve(resizedBase64);
    };
    
    img.onerror = reject;
  });
}

// 将黑白mask转为蓝色透明
function convertImage(base64Data) {
    // console.time('=========convertImage==========')
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64Data;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const pixels = imageData.data;
      
      for (let i = 0; i < pixels.length; i += 4) {
        const red = pixels[i];
        const green = pixels[i + 1];
        const blue = pixels[i + 2];
          // Set non-black pixels to rgba(30, 144, 255, 0.8)
        pixels[i] = 30;
        pixels[i + 1] = 144;
        pixels[i + 2] = 255;
        pixels[i + 3] = red/255 * 204;
      }
      
      ctx.putImageData(imageData, 0, 0);
      const convertedData = canvas.toDataURL();

      // console.timeEnd('=========convertImage==========')

      resolve(convertedData);
    };
    
    img.onerror = (error) => {
      reject(error);
    };
  });
}

// 将图片url转成base64
async function urlToBase64(url) {
    // console.time('=========urlToBase64==========')
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        // console.timeEnd('=========urlToBase64==========')
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
}

// 将base64转 file 对象
function convertBase64ToFile(base64Image, fileName) {
    // console.time('=========convertBase64ToFile==========')
    const base64 = base64Image.split(',')[1];
    const byteArray = atob(base64);
    const arrayBuffer = new ArrayBuffer(byteArray.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteArray.length; i++) {
      uint8Array[i] = byteArray.charCodeAt(i);
    }
    const blob = new Blob([arrayBuffer], { type: 'image/png' });
    const file = new File([blob], fileName, { type: 'image/png' });

    // console.timeEnd('=========convertBase64ToFile==========')
    return file;
}

// 将图片某种颜色转化为另一种颜色
function replaceColor(base64, fromColor, toColor) {
    // console.time('=========replaceColor==========')
  return new Promise(resolve => {
    const image = new Image();
    image.onload = function() {
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;

      const context = canvas.getContext('2d');
      context.drawImage(image, 0, 0);

      const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      // 将颜色字符串转换为 RGBA 格式，并添加透明度值
      const fromRGBA = `rgba(${fromColor.r}, ${fromColor.g}, ${fromColor.b}, ${fromColor.a})`;
      const toRGBA = `rgba(${toColor.r}, ${toColor.g}, ${toColor.b}, ${toColor.a})`;

      for (let i = 0; i < data.length; i += 4) {
        // 将原颜色替换为指定颜色
        if (data[i] === fromColor.r && data[i + 1] === fromColor.g && data[i + 2] === fromColor.b) {
          data[i] = toColor.r;
          data[i + 1] = toColor.g;
          data[i + 2] = toColor.b;

          // 根据 toColor 的透明度调整新的透明度值
          data[i + 3] = Math.round(data[i + 3] * toColor.a / fromColor.a);
        }
      }

      context.putImageData(imageData, 0, 0);

      const newBase64 = canvas.toDataURL();

      // console.timeEnd('=========replaceColor==========')

      resolve(newBase64);
    };
    image.src = base64;
  });
}

function downloadFileWithToken (fileUrl, fileName) {
  if (!fileName) fileName = fileUrl.replace(/.+\/([^\/]+$)/, '$1')
  return axios({
    method: 'get',
    url: fileUrl,
    headers: {
      'Ps-Auth-Token': localStorage.getItem('token')
    },
    responseType: 'blob' // 希望后端返回Blob类型属性
  }).then(res => {
    const blob = new Blob([res.data], {	
        // 创建一个新的Blob对象来接收后端的文件,这里第一个参数必须是数组类型，否则下载必出错。
        type: 'application/octet-stream' 
        // type，表明该 Blob 对象所包含数据的 MIME 类型,这需要前后端统一规划
    })
    let link = document.createElement('a')	
    let body = document.querySelector('body')
    link.href = window.URL.createObjectURL(blob) // 创建一个下载文件的URL，它指向blob，因为Blob对象在之前在接收后端发来的文件流信息。因为是Blob对象，所以不会跳转页面
    
    link.download = fileName || 'download' // 自己制定下载文件的文件名
    // 兼容火狐浏览器
    link.style.display = 'none'	// 让这个a标签不可见
    body.appendChild(link)
    link.click()		// 创建了新的a标签之后模拟点击事件，开始传输文件
    body.removeChild(link)	// 下载完成之后，移除按钮，垃圾回收，减少页面内存消耗
    window.URL.revokeObjectURL(link.href)	// 移除之前使用createObjectURL创建的URL，垃圾回收
  })
}

// 手机号验证
function validateContact(contact) {
  const phoneReg = /^1[3456789]\d{9}$/;
  const emailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/

  if (phoneReg.test(contact)) {
    return true;
  }
//   if (emailReg.test(contact)) {
//     return true;
//   }
  // 不是手机号也不是邮箱地址
  return false;
}

function downUrl(fileUrl, imageType, isHD) { //第二个参数是埋点需要
  useroplog(imageType, 'function', 'download', isHD ? {'downUrl_HD': fileUrl} : {'downUrl': fileUrl})


  function isBase64(src) {
    // 检查是否以 data: 开头
    return /^data:image\/[a-z]+;base64,/.test(src);
  }
  if (isBase64(fileUrl)) {
    let link = document.createElement('a')	
    link.href = fileUrl
    link.download = `file_${new Date().getTime()}.png` // 自己制定下载文件的文件名
    // 兼容火狐浏览器
    link.style.display = 'none'	// 让这个a标签不可见
    document.body.appendChild(link)

    link.click()
    document.body.removeChild(link);
    return
  }
  return axios({
    method: 'get',
    url: fileUrl,
    responseType: 'blob'
  }).then(res => {
    console.log(fileUrl);
    const fileName = fileUrl.split('?')[0].split('/').pop();
    const fileExtension = fileName.split('.').pop(); // 获取文件类型后缀
  
    const blob = new Blob([res.data], {
      type: `application/octet-stream.${fileExtension}` // 添加文件类型后缀
    });
  
    let link = document.createElement('a');
    let body = document.querySelector('body');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName || 'download';
    link.style.display = 'none';
    body.appendChild(link);
    link.click();
    body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  });
}

// 延迟执行函数
function delayFunc (timeout=3000) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, timeout)
  })
}

//输出图像的长短边
function getLongestSideLength(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = function() {
      const width = img.width;
      const height = img.height;
      const longestSide = Math.max(width, height);
      const shortestSide = Math.min(width, height);

      resolve({ longestSide, shortestSide });
    };

    img.onerror = function() {
      reject(new Error('Failed to load image'));
    };

    img.src = url;
  });
}

// 裁剪图片
function cropImageBase64(base64, x, y, width, height) {
    // console.time('=========cropImageBase64==========')
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = base64;

    image.onload = function () {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      canvas.width = width;
      canvas.height = height;

      context.drawImage(image, x, y, width, height, 0, 0, width, height);

      const croppedBase64 = canvas.toDataURL('image/png');

      // console.timeEnd('=========cropImageBase64==========')
      
      resolve(croppedBase64);
    };

    image.onerror = function (error) {
      reject(error);
    };
  });
}

// 获取图片宽高
function getImageDimensions(base64Image) {
    // console.time('=========getImageDimensions==========')
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = function() {
      const { width, height } = this;

      // console.timeEnd('=========getImageDimensions==========')

      resolve({ width, height });
    };
    img.onerror = function() {
      reject(new Error('Failed to load image.'));
    };
    img.src = base64Image;
  });
}

function convertNonTransparentToColor(base64, color) {
    // console.time('=========convertNonTransparentToColor==========')
  return new Promise(function(resolve, reject) {
    var image = new Image();
    image.src = base64;

    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');

    image.onload = function() {
      canvas.width = image.width;
      canvas.height = image.height;
      context.drawImage(image, 0, 0);

      var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      var data = imageData.data;

      for (var i = 0; i < data.length; i += 4) {
        var alpha = data[i + 3];

        if (alpha !== 0) {
          data[i] = color[0];     // Red component
          data[i + 1] = color[1]; // Green component
          data[i + 2] = color[2]; // Blue component
        }
      }

      context.putImageData(imageData, 0, 0);

      var convertedBase64 = canvas.toDataURL();

      // console.timeEnd('=========convertNonTransparentToColor==========')

      resolve(convertedBase64);
    };

    image.onerror = function() {
      reject(new Error('Failed to load the image.'));
    };
  });
}

// file对象转base64
function convertFileToBase64(file) {
    // console.time('=========convertFileToBase64==========')
  return new Promise((resolve,reject)=>{
    const fileReader = new FileReader();
      fileReader.onload = (e) => {
        // console.timeEnd('=========convertFileToBase64==========')
        resolve(e.target.result);
      };
      fileReader.readAsDataURL(file); // file 或 raw
      fileReader.onerror = () => {
        reject(new Error('文件流异常'));
      };
  })
}

// 判断输入图是否大于4096，超过则resize
function resizeImage4096(base64Image, imgType='image/png') {
    // console.time('=========resizeImage4096==========')
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = function () {
      const canvas = document.createElement('canvas');
      let width = img.width;
      let height = img.height;

      if (Math.max(width, height) > 4096) {
        const aspectRatio = width / height;
        if (width > height) {
          width = 4096;
          height = Math.floor(width / aspectRatio);
        } else {
          height = 4096;
          width = Math.floor(height * aspectRatio);
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        const resizedBase64 = canvas.toDataURL(imgType);
        // console.timeEnd('=========resizeImage4096==========')
        resolve(resizedBase64);
      } else {
        // console.timeEnd('=========resizeImage4096==========')
        resolve(base64Image);
      }
    };

    img.onerror = function () {
      reject(new Error('Failed to load image'));
    };

    img.src = base64Image;
  });
}

// 超分下载img，不带其他参数（用于AI编辑画质升级、普通下载，不消耗虹豆）
const hdDownloadFunc = async ({imgPath='', scale=1, imgSrc='', maskCloth=''}, setLoading=()=>{}) => {
  const getaisuperresolutionResult = (id)  => {
    return new Promise((resolve, reject) => {
      const loopFetch = () => {
        axios.post(API.aisuperresolutionPredictionUrl + id,  {}, {
            headers: {
                'Content-type' : 'application/json',
                'Ps-Auth-Token': localStorage.getItem('token')
            }
        }).then(res => {
            if((res.data.code == 0 && res.data.data.status == 'succeeded')) {
                resolve(res.data.data.output)
            } else if(res.data.data.code == 0 && res.data.data.status == 'failed') {
                reject(new Error(res.data.data.errcode))
            } else {
                let timeout = setTimeout(() => {
                    clearTimeout(timeout)
                    loopFetch()
                }, 400)       
            }
        }).catch(err => {
            reject(err)
        })
      }
      loopFetch()
    })
  }
  function isBase64(src) {
    // 检查是否以 data: 开头
    return /^data:image\/[a-z]+;base64,/.test(src);
  }
  // 超分
  setLoading(true)
  try {
    if (isBase64(imgPath)) {
      let formdata = new FormData
      formdata.append('file', convertBase64ToFile(imgPath, 'image.png'))
      const res = await API.uploadImage(formdata)
      if (res.code != 0) throw new Error(res.message)
      imgPath = res.data.filename
    }
    const res = await API.aisuperresolutionPrediction({
        img_path: imgPath,
        upscale: scale,
        img_src: imgSrc,
        mask_cloth: maskCloth,
        aiEdit: 1,
    })
    if(res.code != 0) throw new Error(res.message)
    const output = await getaisuperresolutionResult(res.data)
    return {
        algoId: res.data,
        output: output
    }
  } catch (err) {
    console.error(err)
    return false
  } finally {
    setLoading(false)
  }
}

const getHDParams = async (taskId, imageType) => {
    let res = await API.commonDownload({taskId})
    if (res?.code != 0) throw new Error(res?.message)
    // console.log('commonDownload', res)
    const imgPath = res.data
    res = await API.getTaskInfo({taskId})
    if (res?.code != 0) throw new Error(res?.message)
    // console.log('getTaskInfo res', res)
    const taskInfo = res.data
    let maskCloth, imgSrc
    if (imageType == IMAGE_TYPE.COMMODITY) {
        const outputs = taskInfo.inpaint?.outputs
        maskCloth = outputs.find(item => /out-gods-aligned_mask-goods/.test(item.image))?.image || outputs[1]?.image
        imgSrc = outputs.find(item => /out-gods-aligned_goods-goods/.test(item.image))?.image || outputs[2].image
    } else {
        const outputs = taskInfo.inpaint?.outputs
        const input = taskInfo.inpaint?.input
        
        if (imageType == IMAGE_TYPE.MODEL || imageType == IMAGE_TYPE.DRESSFORM) {
            maskCloth = input?.mask_path_cloth // 服装参数
        } else {
            maskCloth = outputs.find(item => /out-tryon-2step-bodymask/.test(item.image))?.image || outputs[1]?.image // clothes
        }
        if (imageType == IMAGE_TYPE.CLOTHES) {
            imgSrc = ''
        } else if (imageType == IMAGE_TYPE.DRESSFORM) {
            imgSrc = outputs.find(item => /return-src-img-mote/.test(item.image))?.image || outputs[2]?.image
        } else {
            imgSrc = input?.img_path
        }
    }
    return {
        img_path: imgPath, // 生成图
        img_src: imgSrc || '', // 原始图
        mask_cloth: maskCloth || '',
    }
} 

// 高清预览
const toHDPreview = async (taskId, imageId, imageType) => {
    try {
        const params = await getHDParams(taskId, imageType)
        let res = await API.aisuperresolutionPrediction({
            ...params,
            upscale: 1,
            aiEdit: 0,
        })
        if (res?.code != 0) throw new Error(res?.message)
        // console.log('algoid', res)
        const hdAlgoId = res.data
        res = await API.setHDImage({
            taskId, imageId, hdAlgoId
        })
        if (res?.code != 0) throw new Error(res?.message)
        return true
    } catch (err) {
        message.error(err.message)
    }
}

/**
 * 返回在容器内图片可以显示的最大宽高
 * @param {number} imgWidth - 图片宽度
 * @param {number} imgHeight - 图片高度
 * @param {number} containerWidth - 容器宽度
 * @param {number} containerHeight - 容器高度
 * @returns 
 */
const getImgMaxSizeInContainer = (imgWidth, imgHeight, containerWidth, containerHeight) => {
  const containerAspectRatio = containerWidth / containerHeight
  const imageAspectRatio = imgWidth / imgHeight
  let maxWidth, maxHeight;
  if (containerAspectRatio > imageAspectRatio) {
      // 容器的宽高比较大，以容器的高度为基准计算最大宽度
      maxHeight = containerHeight;
      maxWidth = isNaN(imageAspectRatio) ? 0 : maxHeight * imageAspectRatio;
  } else {
      // 图片的宽高比较大，以容器的宽度为基准计算最大高度
      maxWidth = containerWidth;
      maxHeight = isNaN(imageAspectRatio) ? 0 : maxWidth / imageAspectRatio;
  }

  return {width: maxWidth, height: maxHeight}
} 

// 构图优化时，浏览器若缩放，将结果图resize到正常尺寸
function resizeModelScale(base64Image, scaleFactor) {
    // console.time('=========resizeModelScale==========')
    if (scaleFactor == 1) return Promise.resolve(base64Image)
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function () {
            const canvas = document.createElement('canvas');
            const width = Math.round(img.width / scaleFactor);
            const height = Math.round(img.height / scaleFactor);
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            const shrunkBase64 = canvas.toDataURL('image/webp', .95);

            // console.timeEnd('=========resizeModelScale==========')

            resolve(shrunkBase64);
        };
        img.onerror = function (error) {
            reject(error);
        };
        img.src = base64Image;
    });
}

/**
 * 转换图片颜色
 * @param {*} base64 
 * @param  {Color[]} colors - 转换的颜色数组，以两个为一对进行转换 
 */
const convertImgColor = (base64, ...colors) => {
    // console.time('=========convertImgColor==========')
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = image.width;
      canvas.height = image.height;
      ctx.drawImage(image, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      for (let i = 0; i < data.length; i += 4) {
        const red = data[i];
        const green = data[i + 1];
        const blue = data[i + 2];
        const alpha = data[i + 3];
    
        // console.log('color？', red, green, blue, alpha)
        // 判断像素颜色是否与原始颜色相等
        for (let colorGroup of colors) {
          if (colorGroup.length != 2) return reject(new Error('参数错误'))
          const [fromColor, toColor] = colorGroup
          if (fromColor.length < 3 || toColor.length < 3) return reject(new Error('参数错误'))
          if (
            (red == fromColor[0] || fromColor[0] == '*') &&
            (green == fromColor[1] || fromColor[1] == '*') &&
            (blue == fromColor[2] || fromColor[2] == '*') &&
            ((fromColor.length < 4 && alpha == 255) || (fromColor.length > 3 && (alpha == fromColor[3] || fromColor[3] == '*')))
          ) {
            // 修改像素颜色为新颜色
            data[i] = toColor[0];
            data[i + 1] = toColor[1];
            data[i + 2] = toColor[2];
            if (fromColor.length > 3) data[i + 3] = toColor[3];
            break // 每组像素点仅改变一次，否则会导致重复覆盖
          }
        }
      }
    
      ctx.putImageData(imageData, 0, 0);

      // console.timeEnd('=========convertImgColor==========')

      resolve(canvas.toDataURL());
    }
    image.onerror = reject
    image.src = base64;
  })
}

function addVersionParamToURL (url, param, paramValue) {
  const urlObject = new URL(url);
  const searchParams = new URLSearchParams(urlObject.search);

  if (searchParams.has(param)) {
    // 如果已经存在版本号参数，则替换现有的版本号值
    searchParams.set(param, paramValue);
  } else {
    // 如果不存在版本号参数，则添加版本号参数
    searchParams.append(param, paramValue);
  }

  urlObject.search = searchParams.toString();
  return urlObject.toString();
}

const parseErrorCode = (errorStr) => {
    const DEFAULT_ERROR_MESSAGE = '图片不合格，请重试'
    const ERROR_MESSAGE = {
        '71000': '点不能为空，请拖拽位置',
        '71001': '区域不能为空，请锁定区域',
        '71002': '资源错误，请刷新页面',
        '71003': '资源错误，请刷新页面',
        '71004': '图片不合格，请重试',
        '71005': '任务排队中，请稍后重试',
        '71006': '资源错误，请刷新页面',
        '71007': '图片不合格，请重试',
        '71008': '请选择预置素材库',
        '71009': '图片资源获取失败，请稍后重试',
        '71010': '资源错误，请刷新页面',
        '71011': '资源错误，请刷新页面',
        '71105': '衣服图不支持',
        '71106': '模特图不合格',
        '72001': '商品类型不支持，请更换服装图',
        '422': '请求参数错误，请刷新重试',
        '502': '服务繁忙，请稍后重试',
        '503': '服务繁忙，请稍后重试',
        '-61201': '服务繁忙，请稍后重试',
        '61449': '图片不合格，请重试',
    }
    const res = /\[(-?\d+)\]/.exec(errorStr)
    const code = res ? res[1] : ''
    return {
        code: code,
        message: ERROR_MESSAGE[code] ? ERROR_MESSAGE[code] : DEFAULT_ERROR_MESSAGE
    }
}

// 解析 Base64 是否包含透明通道
function hasAlphaChannel(base64String) {
    return new Promise(function(resolve, reject) {
        var img = new Image();
        img.crossOrigin = 'anonymous'; // 设置跨域属性，避免污染 canvas
        img.onload = function() {
            var canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;

            var context = canvas.getContext('2d');
            context.drawImage(img, 0, 0);

            var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
            var data = imageData.data;

            for (var i = 3; i < data.length; i += 4) {
                if (data[i] < 255) {
                    resolve(true); // 存在透明通道
                    return;
                }
            }
            resolve(false); // 不存在透明通道
        };
        img.onerror = function() {
            reject(new Error('Failed to load image'));
        };
        img.src = base64String;
    });
}

// 判断file文件比例不超过2：1
// 图片大小≤10MB
function validateImageFile(file) {
    return new Promise((resolve, reject) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/webp'|| file.type === 'image/avif';
        if (!isJpgOrPng) return reject(new Error('您只能上传JPG/PNG/WEBP/AVIF格式的文件'))
        if (file.size / 1024 / 1024 > 10) return reject(new Error('图片大小应该≤10MB'))  

        const reader = new FileReader();
        reader.onload = function(event) {
            const img = new Image();
            img.onload = function() {
                const width = img.naturalWidth;
                const height = img.naturalHeight;
                const aspectRatio = width / height;
                // if (width < 512 || height < 512) return reject(new Error('图片尺寸不小于512*512'))
                if (aspectRatio > 2 || aspectRatio < 0.5) return reject(new Error('图片比例不超过2:1'))
                resolve(true)
            };
            img.onerror = function() {
                reject(new Error("无法读取图像文件"));
            };
            img.src = event.target.result;
        };
        reader.onerror = function() {
            reject(new Error("无法读取文件"));
        };
        reader.readAsDataURL(file);
    }).catch(err => {
        message.warning(err.message);
        return false
    })
  
}

// 判断设备是否为手机
function isMobileDevice() {
    return isMobile
}

// 上传base64图片
function uploadBase64Image (base64) {
    let formdata1 = new FormData
    formdata1.append('file', convertBase64ToFile(base64, 'image.png'))
    return API.uploadImage(formdata1).then(res => {
        if (res?.code != 0) throw new Error(res?.message)
        return res?.data?.filename
    }).catch(err => {
        console.error(err);
        message.warning(err.message);
        return false;
    })
}
// 上传file图片，不走审核
function uploadFile (file) {
    let formdata1 = new FormData
    formdata1.append('file', file)
    return API.uploadImage(formdata1).then(res => {
        if (res?.code != 0) throw new Error(res?.message)
        return res?.data?.filename
    }).catch(err => {
        console.error(err);
        message.warning(err.message);
        return false;
    })
}
/*
    埋点
    imageType：可选model dressform commodity clothes
    opType  可选algorithm function resource

    其中算法类：

    智能补光 aiFillLight
    智能美化 aiBeauty
    魔法擦除 aiRemove
    画质升级 aiQualityUpgrade
    随心变形aiDraggan
    其中智能补光、智能美化为前端算法，画质升级和高清图同为SR算法，此三类建议埋点

    功能类：

    跳转 navigation
    选择图片类型 imageType
    换模特 changeModel
    换背景 changeBackgroud
    复刻 reprint
    生成更多 generateMore
    下载 download
    以上功能需埋点。attr可传一个json对象，例如下载，需传用户下载的具体图片
*/
function useroplog(imageType, opType, opName, attr) {
    API.useroplog({
        imageType: imageType? imageType: IMAGE_TYPE.MODEL,
        opType: opType,
        opName: opName,
        attr: attr,
    }).catch(() => {})
}

// 检查上传图片是否符合安全规范
const checkImageIslegal = async (file, cm = 0) => {
  try {
      if (file instanceof Array) {
          const res = await Promise.all(file.map(file => {
              let formdata = new FormData();
              formdata.append('file', file);
              formdata.append('cm', cm);
              return API.uploadImage(formdata);
          }));

          const errRes = res.some(item => item.code !== 0);
          
          if (errRes) {
              const errRes2 = res.some(item => item.code === -5024);
              if (errRes2) {
                  return -5024;
              } else {
                  throw new Error(errRes.message);
              }
          } else {
              if (cm === 1) {
                  const imageAntispamId = res?.data?.imageAntispamId;
                  return {
                      imageAntispamId,
                      data: res.map(item => item.data.filename)
                  };
              }
              return res.map(item => item.data.filename);
          }
      } else {
          let formdata = new FormData();
          formdata.append('file', file);
          formdata.append('cm', cm);
          const res = await API.uploadImage(formdata);

          if (res.code === 0) {
              if (cm === 1) {
                  const imageAntispamId = res?.data?.imageAntispamId;
                  return {
                      imageAntispamId,
                      data: res.data.filename
                  };
              } else {
                  return res.data.filename;
              }
          } else if (res.code === -5024) {
              return -5024;
          } else {
              throw new Error(res.message);
          }
      }
  } catch (err) {
      console.error(err);
      message.warning(err.message);
      return false;
  }
};

// 打开本地文件夹
const openFile = (multiple = false) => {
  return new Promise((resolve, reject) => {
    let fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.multiple = multiple;
    fileInput.addEventListener('change', function() {
      if(multiple) {
          let files = fileInput.files;
          if (files.length > 0) {
            resolve(files)
          }
      } else {
          let file = fileInput.files[0];
          if (file) {
            resolve(file)
          }
      }
    });
    fileInput.click();
  })
};

function addCommasToNumber(input) {
  let str = '';
  
  if (typeof input === 'number') {
    str = input.toString();
  } else if (typeof input === 'string') {
    str = input;
  } else {
    return;
  }
  
  str = str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  
  return str;
}



export default {
    getForegroundImage: getForegroundImage,
    resizeBase64Image: resizeBase64Image,
    urlToBase64: urlToBase64,
    resizeLongestAndShort: resizeLongestAndShort,
    convertBase64Image: convertBase64Image,
    convertBase64ToFile: convertBase64ToFile,
    getTrimmedImageBase64: getTrimmedImageBase64,
    replaceColor: replaceColor,
    chunkArray: chunkArray,
    downloadFileWithToken: downloadFileWithToken,
    validateContact: validateContact,
    downUrl: downUrl,
    delayFunc: delayFunc,
    getLongestSideLength: getLongestSideLength,
    cropImageBase64: cropImageBase64,
    getImageDimensions: getImageDimensions,
    convertNonTransparentToColor,
    convertFileToBase64,
    convertImage,
    resizeImage4096,
    hdDownloadFunc,
    getImgMaxSizeInContainer,
    resizeModelScale,
    convertImgColor,
    setOpaquePixels,
    addVersionParamToURL,
    parseErrorCode,
    hasAlphaChannel,
    isMobileDevice,
    uploadBase64Image,
    uploadFile,
    validateImageFile,
    useroplog,
    checkImageIslegal,
    getHDParams, // 根据taskid获得高清生成参数
    toHDPreview, // 高清预览生成
    openFile,
    addCommasToNumber
}